import {
  GetAgencyDestination,
  EditAgencyDestination,
  InsertAgencyDestination,
  DeleteAgencyDestination,
} from "../type";
const initialState = {
  getAgencyDestination: [],
  InsertAgencyDestination: [],
  UpdateAgencyDestination: [],
  DeleteAgencyDestination: [],

  loading: true,
};
const AgencyDestinationR = (state = initialState, action) => {
  switch (action.type) {
    case GetAgencyDestination:
      return {
        ...state,
        getAgencyDestination: action.payload,
        loading: false,
      };
    case InsertAgencyDestination:
      return {
        getAgencyDestination: state.getAgencyDestination,
        InsertAgencyDestination: action.payload,
        loading: false,
      };
    case EditAgencyDestination:
      return {
        getAgencyDestination: state.getAgencyDestination,
        UpdateAgencyDestination: action.payload,
        loading: false,
      };
      case DeleteAgencyDestination:
        return {
          getAgencyDestination: state.getAgencyDestination,
          DeleteAgencyDestination: action.payload,
          loading: false,
        };
    default:
      return state;
  }
};
export default AgencyDestinationR;
